import React from 'react';
import myImage from './kachel_sonderloesungen.jpg';

const kachelSonderloesungen = () => {
    return (
        <img src={myImage} width="100" height="50" />
    )
}

export default kachelSonderloesungen;



